<template>
  <v-container>
    <barra
    v-bind:setbtndefault="setbuttonbarra"
     />
    <v-card>
      <v-card-title class="grey lighten-4 change-font" primary-title>
        <v-toolbar-title>Planes Nacionales de la Reforma Rural Integral – PNRRI</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="d-flex">
            <img
              id="pns"
              alt="PNS"
              height="90"
              :src="imgUrl + 'pns-simbolo.png'"
              class="gray float-left mr-3"
            />
            <span class="float-right mt-3 mt-3">{{ intro }}</span>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card>
          <v-card-title>Avance acumulado</v-card-title>
          <v-card-text>
            <p>Conozca el avance de la implementación cada uno de los 16 Planes Nacionales de la Reforma Rural Integral – PNRRI 
              <v-tooltip bottom> <template v-slot:activator="{ on }">
              <v-btn icon color="info"> <v-icon v-on="on">fa-info-circle</v-icon> </v-btn>
              </template> <span>Los {{ countNacional }} planes presentados son lo que se encuentran aprobados hasta la fecha</span>
              </v-tooltip>
              </p>
              
              
            
            <v-row class="pl-4 pr-4 pb-0 mb-0">
              <v-col
                v-for="item in DataNacional"
                :key="item.idnacional"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                class="plan mb-4"
              >
                <router-link style="text-decoration: none;"
                  :to="'vistaciuddanodetallato/' + item.idnacional"
                  :title="'Más detalles de ' + item.nombre + '...'"
                >
                <span class="avance" :style="'color:' + item.color">
                    {{ item.avance }}
                    <small>%</small>
                  </span>
                  <v-progress-linear
                    height="10"
                    :color="item.color"
                    background-opacity="0.2"
                    :value="item.avance"
                  />
                  <span style="color:black">{{ item.nombre }}</span>
                </router-link>
              </v-col>
            </v-row>
				<v-layout>
					<v-flex class="pb-0">
            <div class="col text-center pt-0 pb-0 pl-0 mt-4" :hidden="BttonHidden">
              <button type="button" class="v-btn theme--light elevation-2 v-size--xlarge primary w-600" @click="gotoTerritorializacionPDET">
                <span class="v-btn__content">Georreferenciación de los indicadores con desagregación territorial</span>
              </button>
            </div>
					</v-flex>
				</v-layout>  

          </v-card-text>
        </v-card>
      </v-card-text>

      <v-card class="mb-8 mt-4">
        <v-card-text justify>
          <p>Los valores de avance corresponden solo a los indicadores, pero no a las estrategias y actividades.</p>
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
let url = process.env.BASE_URL;
import barra from "@/components/content/barra-nav.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "vistaciudadano",
  components: {
    barra
  },
  data() {
    return {
      BttonHidden: true,
      imgUrl: url + "img/",
      countNacional:0,
      intro: "",
      DataNacional: [{ idnacional: 0, nombre: "", color: "", avance: "" }],
      setbuttonbarra: 0,
    };
  },
  methods: {
    ...mapActions(["get_vistanacional"]),
    SetButtons(){
        let payload = { boton: 0 };
        this.$store.dispatch("barra/setstate", payload);
    },
    gotoTerritorializacionPDET()
		{
			// Nota se queman los valores de Punto y clasificador
			// se llama ese formulario desde aqui con esos valores predeterminados y no va a cambiar.
			let link = "/territorialfromPNS"; 
      this.$router.push(link);
		},    
  },
  created() {
    this.SetButtons();
    this.get_vistanacional();
  },
  computed: {
    ...mapGetters(["gvistanacional"]),
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"])
  },
  watch: {
    gvistanacional: function() {
      this.setbuttonbarra = 1;
      this.DataNacional = [];
      this.gvistanacional.forEach(element => {
        this.DataNacional.push({
          idnacional: element.idnacional,
          nombre: element.nombre,
          color: element.color,
          avance: element.avanceGeneralFormat
        });
      });
      this.countNacional = this.DataNacional.length
      this.intro = 
        "El Acuerdo de Paz en el marco del Punto 1, estableció el compromiso de formular e implementar 16 planes nacionales para la Reforma Rural Integral, con el objetivo de contribuir a la superación de la pobreza y la desigualdad para alcanzar el bienestar de la población rural, la integración y el cierre de la brecha entre el campo y la ciudad.";
    },
    gperiodo: function() {
      this.DataNacional = [];
      console.log('LLena data nacional')
        this.gvistanacional.forEach(element => {
          let valavance = 0;
          if (this.gperiodo == 0) {
            valavance = element.avanceGeneralFormat;
          } else if (this.gperiodo > 0)
          {
            let periodos = element.avancesperiodos
            let periodofiltrado = periodos.filter(
                p => p.idperiodo === this.gperiodo
            )
            if (periodofiltrado.length > 0  )
            {
              valavance = periodofiltrado[0].promedioAvanceFormat
            }
          }
          this.DataNacional.push({
            idnacional: element.idnacional,
            nombre: element.nombre,
            color: element.color,
            avance: valavance
          });
        });
    }
  }
};
</script>